import React, { useCallback } from 'react';

import HomeBarButton from '../../HomeBarButton/HomeBarButton';
import { useMytaverse } from '@providers/MytaverseProvider';
import { useClientSpecificVirtualAssistant } from '@hooks/clientSpecificUtils';

import { useStyles } from './styles';
import { useVirtualAssistantContext } from '@core/dashboard/components/HomeBottomBar/VirtualAssistant/context/context';
import { useMytaverseEvent } from '@core/dashboard/providers';
import { AnalyticsType } from '@interfaces/analytics';
import { SxProps } from '@mui/material';

import { env } from 'env';
let { REACT_APP_VIRTUAL_ASSISTANT_DISABLED_EVENT_TAG } = env;

enum VirtualAssistantActions {
  TOGGLE = 'TOGGLE_VIRTUAL_ASSISTANT',
}

const VirtualAssistant = ({ sx = {} }: { sx?: SxProps }) => {
  const classes = useStyles();
  const { sendMessageToUnreal } = useMytaverse();
  const { trackEventAnalytics, currentEvent } = useMytaverseEvent();

  const { isActive, isGlowing } = useVirtualAssistantContext();

  const assistantData = useClientSpecificVirtualAssistant();
  const handleToggleAssistant = useCallback(() => {
    sendMessageToUnreal({
      action: VirtualAssistantActions.TOGGLE,
    });
    trackEventAnalytics(AnalyticsType.ToggleVirtualAssistant);
  }, [sendMessageToUnreal, trackEventAnalytics]);

  if (
    currentEvent?.eventTags?.includes(
      REACT_APP_VIRTUAL_ASSISTANT_DISABLED_EVENT_TAG as string,
    )
  ) {
    return null;
  }

  return (
    <HomeBarButton
      handleClick={handleToggleAssistant}
      icon={assistantData.icon}
      disabled={!isActive}
      label={assistantData.label}
      buttonSx={{ ...classes.button(isGlowing), ...sx }}
    />
  );
};

export default VirtualAssistant;
